import i18n from 'i18next';

import type badgeVariants from '@/lib/badge-variants';
import type { VariantProps } from 'class-variance-authority';

import isAfterToday from '@/utils/helpers/is-after-today';

type BadgeVariant = VariantProps<typeof badgeVariants>['variant'];

interface getReleaseNotePublishStatusProps {
  isPublished: boolean;
  releaseDate: Date | string;
}
interface PublishStatus {
  variant: BadgeVariant;
  badgeText: string;
}

const getReleaseNotePublishStatus = ({
  isPublished,
  releaseDate,
}: getReleaseNotePublishStatusProps): PublishStatus => {
  const isScheduled = isAfterToday(new Date(releaseDate));

  if (isScheduled && isPublished) {
    return {
      variant: 'info',
      badgeText: i18n.t('common.scheduled'),
    };
  } else if (!isScheduled && isPublished) {
    return {
      variant: 'success',
      badgeText: i18n.t('label.published'),
    };
  }

  return {
    variant: 'secondary',
    badgeText: i18n.t('label.unpublished'),
  };
};
export default getReleaseNotePublishStatus;
